import { RootState, useAppSelector } from '../redux/store';
import { setAuthToken } from '../redux/http';

// Check Authentication
export const useIsAthenticatedUser = () => {
  const user = useAppSelector(
    (state: RootState) => state?.currentUser?.loginUser
  );
  const token = user?.data?.accessToken;
  if (!token) {
    return false;
  }
  setAuthToken(token);
  return true;
};

// TruncateString Fn
export function truncateString(text: string, maxWords: number): string {
  const words: string[] = text?.split(' ');
  if (words?.length <= maxWords) {
    return text;
  }
  const truncatedText: string = words?.slice(0, maxWords)?.join(' ');
  return truncatedText + '...';
}
